"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _TooltipModule = _interopRequireDefault(require("./Tooltip.module.scss"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var getSignByPosition = function getSignByPosition(position) {
  switch (position) {
    case 'top':
      return -1;

    case 'left':
      return -1;

    case 'right':
      return 1;

    case 'bottom':
      return 1;

    default:
      return 0;
  }
};

var getPositionsPrioritiesByPosition = function getPositionsPrioritiesByPosition(position) {
  switch (position) {
    case 'top':
      return ['top', 'bottom', 'right', 'left'];

    case 'bottom':
      return ['bottom', 'top', 'right', 'left'];

    case 'left':
      return ['left', 'right', 'top', 'bottom'];

    case 'right':
      return ['right', 'left', 'top', 'bottom'];

    default:
      return ['top', 'bottom', 'right', 'left'];
  }
};

var calculateAlignment = function calculateAlignment(triggerProp, tooltipProp, align) {
  switch (align) {
    case 'start':
      return 0;

    case 'center':
      return (triggerProp - tooltipProp) / 2;

    case 'end':
      return triggerProp - tooltipProp;
  }
};

var getArrowPosition = function getArrowPosition(align, position, offset) {
  var offsetStyle = getArrowOffset(align, position, offset);

  switch (position) {
    case 'top':
      return _extends({
        top: '100%'
      }, offsetStyle);

    case 'bottom':
      return _extends({
        top: 0
      }, offsetStyle);

    case 'left':
      return _extends({
        left: '100%'
      }, offsetStyle);

    case 'right':
      return _extends({
        left: 0
      }, offsetStyle);
  }
};

var getArrowOffset = function getArrowOffset(align, position, offset) {
  if (position === 'top' || position === 'bottom') {
    var transform = 'translateY(-50%) rotate(45deg)';

    switch (align) {
      case 'start':
        return {
          left: offset,
          transform: "".concat(transform)
        };

      case 'center':
        return {
          left: '50%',
          transform: "translateX(-50%) ".concat(transform)
        };

      case 'end':
        return {
          right: offset,
          transform: "".concat(transform)
        };
    }
  } else {
    var _transform = 'translateX(-50%) rotate(45deg)';

    switch (align) {
      case 'start':
        return {
          top: offset,
          transform: "".concat(_transform)
        };

      case 'center':
        return {
          top: '50%',
          transform: "translateY(-50%) ".concat(_transform)
        };

      case 'end':
        return {
          bottom: offset,
          transform: "".concat(_transform)
        };
    }
  }
};

var isCoverTriggerBorder = function isCoverTriggerBorder(triggerBorderPos, tooltipStart, tooltipEnd) {
  if (triggerBorderPos >= tooltipStart && triggerBorderPos <= tooltipEnd) {
    return true;
  }

  return false;
};

var isCoverTrigger = function isCoverTrigger(_ref) {
  var top = _ref.top,
      bottom = _ref.bottom,
      left = _ref.left,
      right = _ref.right,
      position = _ref.position,
      triggerTop = _ref.triggerTop,
      triggerBottom = _ref.triggerBottom,
      triggerLeft = _ref.triggerLeft,
      triggerRight = _ref.triggerRight;

  switch (position) {
    case 'top':
      return isCoverTriggerBorder(triggerTop, top, bottom);

    case 'bottom':
      return isCoverTriggerBorder(triggerBottom, top, bottom);

    case 'left':
      return isCoverTriggerBorder(triggerLeft, left, right);

    case 'right':
      return isCoverTriggerBorder(triggerRight, left, right);
  }
};

var shiftFromBorders = function shiftFromBorders(rawTop, rawLeft, tooltipWidth, tooltipHeight, windowWidth, windowHeight, viewportOffset) {
  var top = rawTop;
  var left = rawLeft;

  if (left < viewportOffset) {
    left = viewportOffset;
  } else if (left + tooltipWidth > windowWidth - viewportOffset) {
    left = windowWidth - viewportOffset - tooltipWidth;
  }

  if (top < viewportOffset) {
    top = viewportOffset;
  } else if (top + tooltipHeight > windowHeight - viewportOffset) {
    top = windowHeight - viewportOffset - tooltipHeight;
  }

  return {
    top: top,
    left: left
  };
};

var TooltipContent = /*#__PURE__*/function (_PureComponent) {
  _inherits(TooltipContent, _PureComponent);

  var _super = _createSuper(TooltipContent);

  function TooltipContent() {
    var _this;

    _classCallCheck(this, TooltipContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.tooltipRef = /*#__PURE__*/_react["default"].createRef();
    return _this;
  }

  _createClass(TooltipContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate();
    }
  }, {
    key: "getTooltipCoordinates",
    value: function getTooltipCoordinates(_ref2) {
      var triggerWidth = _ref2.triggerWidth,
          triggerHeight = _ref2.triggerHeight,
          triggerLeft = _ref2.triggerLeft,
          triggerTop = _ref2.triggerTop,
          tooltipHeight = _ref2.tooltipHeight,
          tooltipWidth = _ref2.tooltipWidth,
          windowWidth = _ref2.windowWidth,
          windowHeight = _ref2.windowHeight,
          viewportOffset = _ref2.viewportOffset,
          position = _ref2.position;
      var _this$props = this.props,
          offsetX = _this$props.offsetX,
          offsetY = _this$props.offsetY,
          align = _this$props.align,
          _this$props$flexible = _this$props.flexible,
          flexible = _this$props$flexible === void 0 ? true : _this$props$flexible;
      var sign = getSignByPosition(position);
      var top = triggerTop;
      var left = triggerLeft;

      if (position === 'top' || position === 'bottom') {
        top += (position === 'top' ? -tooltipHeight : triggerHeight) + sign * offsetY;
        left += calculateAlignment(triggerWidth, tooltipWidth, align);
      } else {
        top += calculateAlignment(triggerHeight, tooltipHeight, align);
        left += (position === 'left' ? -tooltipWidth : triggerWidth) + sign * offsetX;
      }

      var _shiftFromBorders = shiftFromBorders(top, left, tooltipWidth, tooltipHeight, windowWidth, windowHeight, viewportOffset),
          shiftedTop = _shiftFromBorders.top,
          shiftedLeft = _shiftFromBorders.left;

      var normalizedTop = flexible ? shiftedTop : top;
      var normalizedLeft = flexible ? shiftedLeft : left;
      return {
        top: normalizedTop,
        left: normalizedLeft,
        bottom: normalizedTop + tooltipHeight,
        right: normalizedLeft + tooltipWidth
      };
    }
  }, {
    key: "getTooltipStyles",
    value: function getTooltipStyles() {
      var tooltip = this.tooltipRef.current;

      if (!tooltip) {
        return;
      }

      var _this$props2 = this.props,
          viewportOffset = _this$props2.viewportOffset,
          withArrow = _this$props2.withArrow,
          _this$props2$arrowOff = _this$props2.arrowOffset,
          arrowOffset = _this$props2$arrowOff === void 0 ? 8 : _this$props2$arrowOff,
          align = _this$props2.align,
          trigger = _this$props2.triggerRef.current;
      var _window = window,
          scrollX = _window.scrollX,
          scrollY = _window.scrollY,
          windowWidth = _window.innerWidth,
          windowHeight = _window.innerHeight;
      var tooltipWidth = tooltip.offsetWidth,
          tooltipHeight = tooltip.offsetHeight;

      var _trigger$getBoundingC = trigger.getBoundingClientRect(),
          triggerWidth = _trigger$getBoundingC.width,
          triggerHeight = _trigger$getBoundingC.height,
          triggerLeft = _trigger$getBoundingC.left,
          triggerTop = _trigger$getBoundingC.top;

      var positionPriorities = getPositionsPrioritiesByPosition(this.props.position);
      var tooltipTop, tooltipLeft, tooltipPosition;

      for (var i = 0; i < 4; i++) {
        var _this$getTooltipCoord = this.getTooltipCoordinates({
          triggerWidth: triggerWidth,
          triggerHeight: triggerHeight,
          triggerLeft: triggerLeft,
          triggerTop: triggerTop,
          tooltipHeight: tooltipHeight,
          tooltipWidth: tooltipWidth,
          windowWidth: windowWidth,
          windowHeight: windowHeight,
          viewportOffset: viewportOffset,
          position: positionPriorities[i]
        }),
            top = _this$getTooltipCoord.top,
            left = _this$getTooltipCoord.left,
            bottom = _this$getTooltipCoord.bottom,
            right = _this$getTooltipCoord.right;

        if (!isCoverTrigger({
          top: top,
          left: left,
          bottom: bottom,
          right: right,
          position: positionPriorities[i],
          triggerTop: triggerTop,
          triggerLeft: triggerLeft,
          triggerBottom: triggerTop + triggerHeight,
          triggerRight: triggerLeft + triggerWidth
        })) {
          tooltipTop = top;
          tooltipLeft = left;
          tooltipPosition = positionPriorities[i];
          break;
        }
      }

      var arrowStyle = withArrow ? getArrowPosition(align, tooltipPosition, "".concat(arrowOffset, "px")) : {};
      return {
        tooltipStyle: {
          top: "".concat(tooltipTop + scrollY, "px"),
          left: "".concat(tooltipLeft + scrollX, "px")
        },
        arrow: arrowStyle
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          position = _this$props3.position,
          align = _this$props3.align,
          className = _this$props3.className,
          onMouseEnter = _this$props3.onMouseEnter,
          onMouseLeave = _this$props3.onMouseLeave,
          children = _this$props3.children,
          offsetX = _this$props3.offsetX,
          offsetY = _this$props3.offsetY,
          withCss = _this$props3.withCss,
          withArrow = _this$props3.withArrow,
          _this$props3$arrowOff = _this$props3.arrowOffset,
          arrowOffset = _this$props3$arrowOff === void 0 ? 8 : _this$props3$arrowOff,
          arrowClassName = _this$props3.arrowClassName;
      var style;
      var arrowStyle;
      var classes;

      if (withCss) {
        var _style;

        var sign = getSignByPosition(position);
        var isVerticalPosition = position === 'top' || position === 'bottom';
        style = (_style = {}, _defineProperty(_style, "margin".concat(sign > 0 ? 'Left' : 'Right'), isVerticalPosition || "".concat(offsetX, "px")), _defineProperty(_style, "margin".concat(sign > 0 ? 'Top' : 'Bottom'), isVerticalPosition && "".concat(offsetY, "px")), _style);
        classes = [_TooltipModule["default"].withCss, _TooltipModule["default"][position], _TooltipModule["default"][align]];

        if (withArrow) {
          arrowStyle = getArrowPosition(align, position, "".concat(arrowOffset, "px"));
        }
      } else {
        var _ref3 = this.getTooltipStyles() || {},
            tooltipStyle = _ref3.tooltipStyle,
            arrow = _ref3.arrow;

        style = tooltipStyle;
        arrowStyle = arrow;
        classes = [];
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.tooltipRef,
        style: style,
        className: _classnames["default"].apply(void 0, [_TooltipModule["default"].tooltip, className].concat(_toConsumableArray(classes))),
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave
      }, withArrow && /*#__PURE__*/_react["default"].createElement("div", {
        style: arrowStyle,
        className: (0, _classnames["default"])(_TooltipModule["default"].arrow, arrowClassName)
      }), children);
    }
  }]);

  return TooltipContent;
}(_react.PureComponent);

var _default = TooltipContent;
exports["default"] = _default;